import { render, staticRenderFns } from "./CoverSection.vue?vue&type=template&id=a3b331ee&scoped=true&"
import script from "./CoverSection.vue?vue&type=script&lang=js&"
export * from "./CoverSection.vue?vue&type=script&lang=js&"
import style0 from "./CoverSection.vue?vue&type=style&index=0&id=a3b331ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b331ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
